module.exports = __webpack_public_path__ + "static/butchi2-3ea9774238895cd18fe0f6160b555a25.jpg";